import * as React from 'react';

const usePopperState = (onChange?: (state: boolean) => void) => {
    const [isOpen, setOpen] = React.useState(false);

    const open = React.useCallback(() => {
        setOpen(true);
        onChange?.(true);
    }, []);

    const close = React.useCallback(() => {
        setOpen(false);
        onChange?.(false);
    }, []);

    const toggle = React.useCallback(() => {
        return isOpen ? close() : open();
    }, [isOpen]);

    return { isOpen, toggle, open, close };
};

export default usePopperState;
